// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditGoalModal_modal__zGy22{
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 400;
}
.EditGoalModal_container__bygjG{
    position: relative;
    width: 85%;
    max-width: 412px;
    padding: 20px;
    background-color: #FFFFFF;
    border: 1px solid #1F363D1A;
    border-radius: 25px;
    box-shadow: 0 3px 12px 0 #00000012;
}
.EditGoalModal_header__dFQKv{
    margin-bottom: 8px;
    color: #1F363D;
    font-size: 31px;
    font-family: 'Gotham Bold', serif;
}
.EditGoalModal_close__pIaKT{
    position: absolute;
    top: 28px;
    right: 33px;
    height: 12px;
    width: 12px;
    cursor: pointer;
}
.EditGoalModal_form__eq\\+be{
    height: calc(100% - 50px);
}
.EditGoalModal_formInputs__CN3\\+w{
    height: calc(100% - 80px);
    overflow-y: auto;
    overflow-x: hidden;
}
.EditGoalModal_input__4mFwq{
    display: block !important;
    margin-top: 20px;
}
.EditGoalModal_input__4mFwq input{
    width: calc(100% - 79px);
}
.EditGoalModal_buttons__JGA6s{
    display: flex;
    margin-top: 35px;
}
.EditGoalModal_buttonsApiError__B1Xhu{
    margin-top: 9px;
}
.EditGoalModal_button__KMwq7{
    width: 194px;
    padding-left: 50px;
    padding-right: 50px;
}
@media(max-width: 500px){
    .EditGoalModal_button__KMwq7{
        width: calc(50% - 6px);
    }
}`, "",{"version":3,"sources":["webpack://./src/components/modals/EditGoalModal.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,oCAAoC;IACpC,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,2BAA2B;IAC3B,mBAAmB;IACnB,kCAAkC;AACtC;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iCAAiC;AACrC;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI;QACI,sBAAsB;IAC1B;AACJ","sourcesContent":[".modal{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: fixed;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    z-index: 400;\n}\n.container{\n    position: relative;\n    width: 85%;\n    max-width: 412px;\n    padding: 20px;\n    background-color: #FFFFFF;\n    border: 1px solid #1F363D1A;\n    border-radius: 25px;\n    box-shadow: 0 3px 12px 0 #00000012;\n}\n.header{\n    margin-bottom: 8px;\n    color: #1F363D;\n    font-size: 31px;\n    font-family: 'Gotham Bold', serif;\n}\n.close{\n    position: absolute;\n    top: 28px;\n    right: 33px;\n    height: 12px;\n    width: 12px;\n    cursor: pointer;\n}\n.form{\n    height: calc(100% - 50px);\n}\n.formInputs{\n    height: calc(100% - 80px);\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n.input{\n    display: block !important;\n    margin-top: 20px;\n}\n.input input{\n    width: calc(100% - 79px);\n}\n.buttons{\n    display: flex;\n    margin-top: 35px;\n}\n.buttonsApiError{\n    margin-top: 9px;\n}\n.button{\n    width: 194px;\n    padding-left: 50px;\n    padding-right: 50px;\n}\n@media(max-width: 500px){\n    .button{\n        width: calc(50% - 6px);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `EditGoalModal_modal__zGy22`,
	"container": `EditGoalModal_container__bygjG`,
	"header": `EditGoalModal_header__dFQKv`,
	"close": `EditGoalModal_close__pIaKT`,
	"form": `EditGoalModal_form__eq+be`,
	"formInputs": `EditGoalModal_formInputs__CN3+w`,
	"input": `EditGoalModal_input__4mFwq`,
	"buttons": `EditGoalModal_buttons__JGA6s`,
	"buttonsApiError": `EditGoalModal_buttonsApiError__B1Xhu`,
	"button": `EditGoalModal_button__KMwq7`
};
export default ___CSS_LOADER_EXPORT___;
